import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';

const SalesSteps = ({ t, currentStep, setCurrentStep }) => {
  const classNameByStep = (step) => {
    let className = 'im-step-bar2__item';
    if (step === currentStep) {
      className = `${className} im-step-bar2__item--inprogress`;
    } else if (step < currentStep) {
      className = `${className} im-step-bar2__item--completed`;
    }
    return className;
  };

  const handleChangeStep = (index, step) => {
    if (currentStep > index) {
      setCurrentStep(step);
    }
  };

  return (
    <div className="col-md-5 col-lg-4">
      <aside>
        <nav className="im-step-bar2 im-step-bar2--numbers">
          <a className={classNameByStep(0)} onClick={() => handleChangeStep(0, 'MachineAddressInformation')}>
            <span className="im-step-bar2__item__text">{t('enterTheMachineAddressInformation')}</span>
          </a>
          <a className={classNameByStep(1)} onClick={() => handleChangeStep(1, 'MachineInformation')}>
            <span className="im-step-bar2__item__text">{t('enterTheMachineInformation')}</span>
          </a>
          <a className={classNameByStep(2)} onClick={() => handleChangeStep(2, 'PersonalInformation')}>
            <span className="im-step-bar2__item__text">{t('enterYourPersonalInformation')}</span>
          </a>
        </nav>
      </aside>
    </div>
  );
};

SalesSteps.propTypes = {
  currentStep: PropTypes.number,
  t: PropTypes.func,
  setCurrentStep: PropTypes.func,
};

export default withTranslation('common')(SalesSteps);
